import LifeCycleManager from './lifecycle-manager';

export default LifeCycleManager;
